import React from "react";
import { LegalPageLayout } from "./LegalPageLayout";

const PublicOffer = () => <LegalPageLayout slug="public-offer" />;

export default PublicOffer;
